import React from "react";
import Icon from "./Icon";

const FILTERS = [["all", "All"], ["upcoming", "Upcoming"], ["completed", "Completed"]];

/** Title, All/Upcoming/Completed filter and the create-or-request button. */
export default function SessionsHeader({ counts, filter, onFilter, canCreate, canRequest, onCreate, onRequest }) {
  return (
    <div className="head">
      <h2>Course sessions<span>{counts.all} scheduled</span></h2>
      <div className="tools">
        <div className="seg" role="group" aria-label="Filter sessions">
          {FILTERS.map(([key, label]) => (
            <button key={key} type="button" className={filter === key ? "on" : ""} aria-pressed={filter === key} onClick={() => onFilter(key)}>
              {label} <b>{key === "all" ? counts.all : counts[key]}</b>
            </button>
          ))}
        </div>
        {canCreate && <button type="button" className="btn btn-p" onClick={onCreate}><Icon n="plus" w={2.4} />New session</button>}
        {canRequest && <button type="button" className="btn btn-o" onClick={onRequest}><Icon n="plus" w={2.4} />Request session</button>}
      </div>
    </div>
  );
}
